export default "__VITE_ASSET__Db$OdoAX__"